// textNode.js

import { useState, useEffect } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const TextNode = ({ id, data }) => {
  const [currText, setCurrText] = useState(data?.text || '{{input}}');
  const [nodeSize, setNodeSize] = useState({ width: 250, height: 160 });

  // Extract variables from text (e.g., {{variableName}})
  const extractVariables = (text) => {
    const regex = /\{\{([a-zA-Z_$][a-zA-Z0-9_$]*)\}\}/g;
    const variables = [];
    let match;
    while ((match = regex.exec(text)) !== null) {
      variables.push(match[1]);
    }
    return [...new Set(variables)]; // Remove duplicates
  };

  // Update node size based on text content
  useEffect(() => {
    const lines = currText.split('\n').length;
    const maxLineLength = Math.max(...currText.split('\n').map(line => line.length));
    
    // Calculate dynamic width and height
    const minWidth = 200;
    const minHeight = 160;
    const charWidth = 7; // Approximate character width in pixels
    const lineHeight = 20; // Approximate line height in pixels
    
    const calculatedWidth = Math.max(minWidth, maxLineLength * charWidth + 40);
    const calculatedHeight = Math.max(minHeight, lines * lineHeight + 80);
    
    setNodeSize({
      width: calculatedWidth,
      height: calculatedHeight
    });
  }, [currText]);

  const handleTextChange = (e) => {
    setCurrText(e.target.value);
  };

  const variables = extractVariables(currText);

  // Create handles for extracted variables
  const handleConfig = [
    { id: 'output', type: 'source', position: Position.Right }
  ];

  // Add input handles for each variable
  variables.forEach((variable, index) => {
    handleConfig.push({
      id: `input-${variable}`,
      type: 'target',
      position: Position.Left,
      top: 25 + (index * 15)
    });
  });

  return (
    <BaseNode
      id={id}
      data={data}
      title="Text"
      handleConfig={handleConfig}
      width={nodeSize.width}
      height={nodeSize.height}
      style={{ minWidth: '250px', minHeight: '120px', overflow: 'visible' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '12px', flex: 1 }}>
        <label style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <span style={{ fontWeight: '500', color: '#555' }}>Text Content:</span>
          <textarea
            value={currText}
            onChange={handleTextChange}
            style={{
              padding: '6px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '12px',
              fontFamily: 'monospace',
              flex: 1,
              minHeight: '60px',
              resize: 'none',
              fontWeight: '400'
            }}
          />
        </label>
        {variables.length > 0 && (
          <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>
            Variables: {variables.join(', ')}
          </div>
        )}
      </div>
    </BaseNode>
  );
}
